const TextIndent = ({ sx, ...props }) => <span sx={{ variant: 'indent', ...sx }} {...props} />

export default TextIndent
